/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class BankAccountService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @param requestBody
     * @returns any Synchronize incoming payments from CSOB PSD2 AIS
     * @throws ApiError
     */
    public bankAccountControllerSyncCsobIncomingPayments(
        requestBody?: {
            dateFrom?: string;
            dateTo?: string;
        },
    ): CancelablePromise<{
        fetched?: number;
        imported?: number;
        skipped?: number;
        matched?: number;
        paidUsers?: number;
        errors?: Array<string>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/bank/csob/sync',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param xWebhookSecret
     * @param requestBody
     * @returns any Webhook-style endpoint for incoming payment synchronization
     * @throws ApiError
     */
    public bankAccountControllerCsobIncomingPaymentWebhook(
        xWebhookSecret?: string,
        requestBody?: Record<string, any>,
    ): CancelablePromise<{
        fetched?: number;
        imported?: number;
        skipped?: number;
        matched?: number;
        paidUsers?: number;
        errors?: Array<string>;
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/webhooks/bank/csob/incoming-payment',
            headers: {
                'x-webhook-secret': xWebhookSecret,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
